import React from "react";
import Theme from "./theme.svg";

function ThemeIcon() {
  return <img src={Theme} alt="Theme Icon" />;
}

export default ThemeIcon;
